"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function FilterChannel(_a) {
    var params = _a.params, setParams = _a.setParams;
    var channels = ra_fetch_1.useApi('backend').index('channels', {
        sort: 'label asc',
    })[0];
    function addChannelId(value) {
        var newParams = __assign({}, params);
        if (value === '') {
            delete newParams.channel_id;
        }
        else {
            newParams.channel_id = value;
        }
        setParams(newParams);
    }
    if (!channels.data.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { className: 'mb-2 sm:mb-0 sm:mr-4' },
        react_1.default.createElement(storybook_1.Forms.Label, null, "Zoek users op kanaal"),
        react_1.default.createElement(storybook_1.Forms.Select, { value: params.channel_id, onChange: function (value) { return addChannelId(value); } },
            react_1.default.createElement("option", { value: '' }, "Kies kanaal"),
            channels.data.map(function (channel, index) {
                return react_1.default.createElement("option", { key: index, value: channel.id }, channel.label);
            })));
}
exports.default = FilterChannel;
